namespace TabAurous.Finance {
    export interface AccountingPeriodForm {
        Code: Serenity.StringEditor;
        CompanyId: Serenity.LookupEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        Details: AccountingPeriodDetailsEditor;
    }

    export class AccountingPeriodForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.AccountingPeriod';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountingPeriodForm.init)  {
                AccountingPeriodForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = AccountingPeriodDetailsEditor;

                Q.initFormType(AccountingPeriodForm, [
                    'Code', w0,
                    'CompanyId', w1,
                    'FromDate', w2,
                    'ToDate', w2,
                    'Details', w3
                ]);
            }
        }
    }
}
